<template>
    <section class="app-ecommerce-details">
        <!-- Alert: No item found -->

        <b-overlay :show="formShow" rounded="sm" no-fade>
            <b-row>
                <b-col cols="12">
                    <!-- Vehiclle Image and Name -->
                    <b-card>
                        <b-tabs vertical nav-wrapper-class="nav-vertical" pills class="tab-class">
                            <b-tab active title="General Information" v-if="$Can('vehicle_information_tab')">
                                <b-card-body class="mt-0 pt-0">
                                    <b-row class="justify-content-between mb-1">
                                        <h1></h1>
                                        <div>
                                            <b-button v-show="$Can('vehicle_activate_btn')" class="mr-1" v-if="vehicleData.status != 'active'" @click="activateVehicle" variant="success">
                                                Activate
                                            </b-button>

                                            <b-button v-show="$Can('vehicle_remove_btn')" class="mr-1" v-if="vehicleData.status != 'deleted'" @click="removeVehicle" variant="danger">
                                                Remove
                                            </b-button>

                                            <b-button v-show="$Can('vehicle_edit_btn')" class="mr-1" @click="editVehicle" variant="primary">
                                                Edit
                                            </b-button>
                                        </div>
                                    </b-row>

                                    <b-row>
                                        <table class=" table  table-bordered table-hover">
                                            <tbody class="text-left">
                                                <tr>
                                                    <td class="item-price bg-secondary text-white w-25">Vehicle Registration</td>
                                                    <td class="w-75">{{ vehicleData.vehicle_reg }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">Type</td>
                                                    <td>{{ vehicleData.type }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">Seat Count</td>
                                                    <td>{{ vehicleData.seat_count }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">Ownership</td>
                                                    <td>{{ vehicleData.ownership }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">MOT Due</td>
                                                    <td>{{ dateFormat(vehicleData.mot_due) }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">Service Due</td>
                                                    <td>{{ dateFormat(vehicleData.service_due) }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">Tax Due</td>
                                                    <td>{{ dateFormat(vehicleData.tax_due) }}</td>
                                                </tr>

                                                <tr>
                                                    <td class="item-price bg-secondary text-white">Status</td>
                                                    <td>
                                                        <template>
                                                            <b-badge v-if="vehicleData.status == 'active'" pill :variant="`light-success`" class="text-capitalize">
                                                                Activated
                                                            </b-badge>

                                                            <b-badge v-if="vehicleData.status == 'passive'" pill :variant="`light-warning`" class="text-capitalize">
                                                                Inactive
                                                            </b-badge>

                                                            <b-badge v-if="vehicleData.status == 'deleted'" pill :variant="`light-danger`" class="text-capitalize">
                                                                Removed
                                                            </b-badge>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-row>
                                </b-card-body>
                            </b-tab>

                            <b-tab title="Files" v-if="$Can('vehicle_files_tab')">
                                <b-card-body class="mt-0 pt-0">
                                    <b-row>
                                        <b-button v-if="$Can('vehicle_files_add_btn')" class="btn-icon ml-auto  mt-1 mb-1" @click="addNewFile()" variant="primary">
                                            Add New File
                                        </b-button>

                                        <table class=" table  table-bordered table-hover table-sm ">
                                            <b-col cols="12" v-if="vehicleData.id != null">
                                                <!-- user suggestion  -->
                                                <div v-for="(data, index) in files" :key="index" class="ml-5 mr-5 mt-2 mb-2">
                                                    <div v-if="data.status == 'A'" class="d-flex justify-content-between align-items-center">
                                                        <b-img src="@/assets/images/file.png" @click="fileEdit(data)" class="mr-50 " style="cursor:pointer" width="30px" />
                                                        <div class="user-page-info pr-1" style="width: 100%">
                                                            <span @click="fileEdit(data)" style="cursor:pointer; font-size:1.1em" class="mb-2">{{ data.fileName }} </span>
                                                        </div>

                                                        <!-- <b-button  variant="primary" @click="invoiceFile(data)" class="btn-icon ml-auto mr-1" style="padding: 1% 1%;" size="sm">
                          Invoice
                        </b-button> -->

                                                        <b-button
                                                            variant="primary"
                                                            target="_blank"
                                                            :href="fileURL + data.fileLink"
                                                            style="cursor:pointer;    margin-right:2px"
                                                            class="btn-icon ml-auto mr-1"
                                                            size="sm"
                                                        >
                                                            <feather-icon icon="DownloadIcon" />
                                                        </b-button>

                                                        <b-button variant="danger" @click="deleteFile(data)" class="btn-icon ml-auto mr-1" style="" size="sm">
                                                            <feather-icon icon="XIcon" />
                                                        </b-button>
                                                    </div>

                                                    <div v-else class="d-flex justify-content-between align-items-center">
                                                        <b-img src="@/assets/images/url.png" @click="linkEdit(data)" class="mr-50 " style="cursor:pointer" width="30px" />
                                                        <div class="user-page-info pr-1" style="width: 100%">
                                                            <span @click="linkEdit(data)" style="cursor:pointer; font-size:1.1em">{{ data.fileName }} </span>
                                                        </div>
                                                        <b-button
                                                            variant="primary"
                                                            target="_blank"
                                                            :href="'https://' + data.fileLink"
                                                            style="cursor:alias;  margin-right:2px"
                                                            class="btn-icon ml-auto mr-1"
                                                            size="sm"
                                                            v-b-tooltip.hover
                                                            title="Go to url adress"
                                                        >
                                                            <feather-icon icon="ExternalLinkIcon" />
                                                        </b-button>

                                                        <b-button variant="danger" @click="deleteFile(data)" class="btn-icon ml-auto mr-1" style="" size="sm">
                                                            <feather-icon icon="XIcon" />
                                                        </b-button>
                                                    </div>
                                                    <hr />
                                                </div>

                                                <div v-if="files.length == 0" class="d-flex justify-content-center align-items-center mt-1 mb-1">
                                                    No Files
                                                </div>
                                            </b-col>
                                        </table>
                                    </b-row>
                                </b-card-body>
                            </b-tab>

                            <b-tab title="Faults" v-if="$Can('vehicle_faults_tab')">
                                <b-row>
                                    <b-col cols="12" lg="12" md="12" sm="12">
                                        <b-table
                                            striped
                                            hover
                                            ref="refUserListTable"
                                            class="position-relative"
                                            :items="vehicleData.fault_list"
                                            responsive
                                            :small="true"
                                            head-variant="dark"
                                            :fields="faultTableColumns"
                                            show-empty
                                            empty-text="No matching records found"
                                        >
                                            <!-- Column: Id -->
                                            <template #cell(id)="data">
                                                <!--   <b-link :to="{ name: 'customer-edit', params: { id: data.item.id } }" class="font-weight-bold"> #{{ data.value }} </b-link>-->
                                                <strong class="text-primary">#{{ data.value }}</strong>
                                            </template>

                                            <!-- Column: Name -->
                                            <template #cell(description)="data">
                                                {{ data.value }}
                                            </template>

                                            <!-- Column: Name -->
                                            <template #cell(date)="data">
                                                {{ data.value }}
                                            </template>

                                            <!-- Column: Status -->
                                            <template #cell(status)="data">
                                                <b-badge v-if="data.value == 'A'" pill :variant="`light-success`" class="text-capitalize">
                                                    Active
                                                </b-badge>

                                                <b-badge v-if="data.value == 'P'" pill :variant="`light-danger`" class="text-capitalize">
                                                    Passive
                                                </b-badge>

                                                <b-badge v-if="data.value == 'D'" pill :variant="`danger`" class="text-capitalize">
                                                    Deleted
                                                </b-badge>
                                            </template>
                                        </b-table>
                                    </b-col>
                                </b-row>
                            </b-tab>

                            <b-tab title="Events" v-if="$Can('vehicle_event_tab')">
                                <b-card no-body class="mb-0">
                                    <b-overlay rounded="sm" no-fade>
                                        <div class="m-2">
                                            <!-- Table Top -->
                                        </div>

                                        <b-table
                                            striped
                                            hover
                                            ref="refUserListTable"
                                            class="position-relative"
                                            :style="vehicleData.event_list.length < 3 ? 'height: 500px' : ''"
                                            :items="vehicleData.event_list"
                                            selectable
                                            select-mode="single"
                                            responsive
                                            :small="true"
                                            head-variant="dark"
                                            :fields="tableColumnsEvents"
                                            show-empty
                                            empty-text="No matching records found"
                                            @row-selected="onEventRowSelected"
                                            :current-page="currentPageEvent"
                                            per-page="15"
                                        >
                                            <!-- Column: Id -->
                                            <template #cell(id)="data">
                                                <!--   <b-link :to="{ name: 'customer-edit', params: { id: data.item.id } }" class="font-weight-bold"> #{{ data.value }} </b-link>-->
                                                <strong class="text-primary">#{{ data.value }}</strong>
                                            </template>

                                            <!-- Column: Name -->
                                            <template #cell(eventDate)="data">
                                                {{ data.value }}
                                            </template>

                                            <!-- Column: Status -->
                                            <template #cell(invoiceStatus)="data">
                                                <b-badge v-if="data.value" pill :variant="`light-success`" class="text-capitalize">
                                                    Invoiced
                                                </b-badge>

                                                <b-badge v-else pill :variant="`light-danger`" class="text-capitalize">
                                                    Not Invoiced
                                                </b-badge>
                                            </template>

                                            <!-- Column: Actions -->
                                        </b-table>

                                        <div class="mx-2 mb-2">
                                            <b-row>
                                                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                                                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                                                </b-col>

                                                <!-- Pagination -->
                                                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                                                    <b-pagination
                                                        v-model="currentPageEvent"
                                                        :total-rows="vehicleData.event_list.length"
                                                        per-page="15"
                                                        first-number
                                                        last-number
                                                        class="mb-0 mt-1 mt-sm-0"
                                                        prev-class="prev-item"
                                                        next-class="next-item"
                                                    >
                                                        <template #prev-text>
                                                            <feather-icon icon="ChevronLeftIcon" size="18" />
                                                        </template>
                                                        <template #next-text>
                                                            <feather-icon icon="ChevronRightIcon" size="18" />
                                                        </template>
                                                    </b-pagination>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-overlay>
                                </b-card>
                            </b-tab>

                            <b-tab title="Timeline" v-if="$Can('vehicle_timeline_tab')">
                                <b-card v-if="vehicleData.timeline ? vehicleData.timeline.length : 0 > 0" style="overflow-y:scroll; height:500px">
                                    <app-timeline class="mt-2">
                                        <app-timeline-item v-for="item in vehicleData.timeline" :key="item.id" :variant="$func.varyant(item.status)" :icon="$func.varicon(item.status)">
                                            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                                                <h6 v-html="item.title"></h6>
                                                <small class="text-muted">{{ $func.dateFormatTimeline(item.created_at) }}</small>
                                            </div>
                                            <small>{{ "By " + item.userNameSurname }} {{item.ipAddress }}</small>
                                        </app-timeline-item>
                                    </app-timeline>
                                </b-card>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <b-modal
                id="modal-file"
                cancel-variant="outline-secondary"
                ok-title="Save File"
                @ok="handleOk"
                @show="resetModal"
                @hidden="resetModal"
                cancel-title="Close"
                :no-close-on-backdrop="true"
                centered
                title="Add New File"
            >
                <b-form ref="fileRules">
                    <b-form-group :state="nameState" invalid-feedback="File Name is required">
                        <label for="fileName">File Name:</label>
                        <b-form-input id="fileName" type="text" :state="nameState" v-model="modalFileName" required placeholder="File Name" />
                    </b-form-group>
                    <b-form-group>
                        <b-form-checkbox class="custom-control-primary" name="check-button" switch inline v-model="selectFileType">
                            <span class="switch-icon-left">
                                <feather-icon icon="FileIcon" />
                            </span>
                            <span class="switch-icon-right">
                                <feather-icon icon="LinkIcon" />
                            </span>
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :state="fileState" invalid-feedback="File is required" v-if="selectFileType">
                        <b-form-file
                            @input="fileSelected"
                            type="file"
                            :state="fileState"
                            required
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            class="animate__animated animate__fadeIn"
                        />
                    </b-form-group>
                    <b-form-group :state="linkState" invalid-feedback="Link is required" v-else>
                        <b-form-input :state="linkState" id="basicInput" v-model="fileLink" required placeholder="Enter Link" class="animate__animated animate__fadeIn" />
                    </b-form-group>
                </b-form>
                <b-col v-if="percentCompleted != 0 && percentCompleted != 100" class="mt-2">
                    <b-progress key="info" animated :value="percentCompleted" show-progress variant="dark" class="'progress-bar-info'" />
                </b-col>
            </b-modal>

            <b-modal
                id="modal-file-update"
                cancel-variant="outline-secondary"
                ok-title="Change File"
                @ok="handleUpdate"
                cancel-title="Close"
                :no-close-on-backdrop="true"
                centered
                title="Add New File"
            >
                <b-form ref="fileRules">
                    <b-form-group :state="nameState" invalid-feedback="File Name is required">
                        <label for="fileName">File Name:</label>
                        <b-form-input id="fileName" type="text" :state="nameState" v-model="modalFileName" required placeholder="File Name" />
                    </b-form-group>
                </b-form>
                <b-col v-if="percentCompleted != 0 && percentCompleted != 100" class="mt-2">
                    <b-progress key="info" animated :value="percentCompleted" show-progress variant="dark" class="'progress-bar-info'" />
                </b-col>
            </b-modal>
        </b-overlay>
    </section>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
("bootstrap-vue");
import { BModal, BAvatar, BCard, BCardBody, BRow, BCol, BImg, BLink, BButton, BAlert, BCardHeader, BCardTitle, VBToggle, BTabs, BTab, BCardText } from "bootstrap-vue";
import moment from "moment";
import vehicleStoreModule from "../vehicleStoreModule";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axiosIns from "@/libs/axios";

import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

// import { avatarText } from '@core/utils/filter'

export default {
    directives: {
        Ripple,
        "b-toggle": VBToggle,
    },

    components: {
        BRow,
        BCol,
        BAlert,
        BLink,
        BCard,
        BButton,
        BAvatar,
        BModal,
        BCardBody,
        BImg,
        BCardHeader,
        BCardTitle,
        BTabs,
        BCardText,
        BTab,
        AppTimeline,
        AppTimelineItem,
    },
    setup() {
        const VEHICLE_APP_STORE_MODULE_NAME = "vehicle";

        // Register module
        if (!store.hasModule(VEHICLE_APP_STORE_MODULE_NAME)) store.registerModule(VEHICLE_APP_STORE_MODULE_NAME, vehicleStoreModule);

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(VEHICLE_APP_STORE_MODULE_NAME)) store.unregisterModule(VEHICLE_APP_STORE_MODULE_NAME);
        });
    },

    data: function() {
        var vehicleData = {
            id: null,
            type: null,
            seat_count: null,
            vehicle_reg: null,
            ownership: null,
            mot_due: null,
            service_due: null,
            tax_due: 0,
            fault_list: [],
            event_list: [],
        };

        const statusOptions = [
            { label: "Active", value: "active" },
            { label: "Passive", value: "passive" },
            { label: "Delete", value: "deleted" },
        ];

        return {
            userData: JSON.parse(localStorage.getItem("userData")),

            vehicleData: vehicleData,
            baseURL: store.state.app.baseURL,

            roleOptions: [],
            statusOptions,
            VehicleId: null,
            formShow: false,
            permissions: [],
            vehicles: [],

            availability: "A",

            startDate: null,
            endDate: null,
            rangeDate: null,

            fetchAvailability: [],

            //FILES
            where: router.currentRoute.name,
            files: [],
            selectFileType: true,
            fileLink: null,
            modalId: null,
            modalFileName: null,
            modalFile: null,
            download: false,
            fileURL: store.state.app.fileURL,
            percentCompleted: 0,

            fetchTeams: [],
            totalRows: 0,

            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: "thousand",
                },

                percent: {
                    numeral: true,
                    numeralPositiveOnly: true,
                    blocks: [2],
                    prefix: "% ",
                    rawValueTrimPrefix: true,
                    numeralIntegerScale: 2,
                },
            },

            config: {
                dateFormat: "d-m-Y",
                mode: "range",
            },
            currentPageEvent: 1,

            faultTableColumns: [
                { key: "description", sortable: true, class: "text-center" },
                { key: "date", sortable: true, class: "text-center" },
                { key: "user", sortable: false, class: "text-center" },
            ],

            tableColumnsEvents: [
                { key: "id", sortable: true, class: "text-center" },
                { key: "eventDate", sortable: true, class: "text-center" },
                { key: "location", sortable: true, class: "text-center" },
                { key: "vendorReference", label: "PO Number", sortable: true, class: "text-center" },
                { key: "invoiceNo", sortable: true, class: "text-center" },
                { key: "invoiceStatus", sortable: true, class: "text-center" },
            ],

            tableColumns: [
                { key: "availability", sortable: true, class: "text-center" },
                { key: "startDate", sortable: true, class: "text-center" },
                { key: "endDate", sortable: true, class: "text-center" },
            ],

            teamTableColumns: [
                { key: "id", sortable: true, class: "text-center" },
                { key: "title", sortable: true, class: "text-center" },
                { key: "foreman", sortable: true, class: "text-center" },
                { key: "staff_count", sortable: true, class: "text-center" },
                { key: "day_rate", sortable: true, class: "text-center" },
                { key: "status", sortable: true, class: "text-center" },
            ],
        };
    },

    created() {
        this.getVehicleById();
    },

    methods: {
        editVehicle() {
            router.push({ name: "vehicle-edit", params: { id: router.currentRoute.params.id } });
        },

        viewVehicle(id) {
            this.formShow = true;
            store
                .dispatch("vehicle/fetchVehicle", { id: id })
                .then((response) => {
                    this.vehicleData = response.data;
                    this.files = response.data.get_files;
                    this.vehicles = response.data.userList;

                    this.formShow = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.formShow = false;
                });
            router.push({ name: "vehicle-view", params: { id: id } });
        },

        activateVehicle() {
            this.$swal({
                title: "Are you sure?",
                text: "",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "Yes, activate the vehicle!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    var tempData = {
                        status: "A",
                        userId: router.currentRoute.params.id,
                    };
                    this.vehicleData.status = "active";

                    store.dispatch("vehicle/vehicleStatus", tempData).then((response) => {
                        if (response.status == 200) {
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: "Successful",
                                    text: "✔️ Vehicle Update Successful",
                                    icon: "ThumbsUpIcon",
                                    variant: "success",
                                },
                            });
                            this.getVehicleById();
                        }
                    });
                }
            });
        },

        terminateVehicle() {
            this.$swal({
                title: "Are you sure?",
                text: "",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, terminate the vehicle!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    var tempData = {
                        status: "P",
                        userId: router.currentRoute.params.id,
                    };
                    this.vehicleData.status = "passive";

                    store.dispatch("vehicle/vehicleStatus", tempData).then((response) => {
                        if (response.status == 200) {
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: "Successful",
                                    text: "✔️ Vehicle Update Successful",
                                    icon: "ThumbsUpIcon",
                                    variant: "success",
                                },
                            });
                            this.getVehicleById();
                        }
                    });
                }
            });
        },

        onEventRowSelected(item) {
            router.push({ name: "event-view", params: { id: item[0].id } });
        },

        removeVehicle() {
            this.$swal({
                title: "Are you sure?",
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, remove the vehicle!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    var tempData = {
                        status: "D",
                        userId: router.currentRoute.params.id,
                    };

                    this.vehicleData.status = "deleted";

                    store.dispatch("vehicle/vehicleStatus", tempData).then((response) => {
                        if (response.status == 200) {
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: "Successful",
                                    text: "✔️ Vehicle Update Successful",
                                    icon: "ThumbsUpIcon",
                                    variant: "success",
                                },
                            });
                            this.getVehicleById();
                        }
                    });
                }
            });
        },

        getVehicleById() {
            this.formShow = true;

            if (router.currentRoute.params.id) {
                this.VehicleId = parseInt(router.currentRoute.params.id);

                store
                    .dispatch("vehicle/fetchVehicle", { id: router.currentRoute.params.id })
                    .then((response) => {
                        if (response.status == 200) {
                            this.vehicleData = response.data;
                            this.files = response.data.get_files;
                            this.vehicles = response.data.userList;

                            this.formShow = false;
                        } else {
                            router.push({ name: "error-404" });
                        }
                    })
                    .catch((error) => {
                        router.push({ name: "error-404" });
                    });
            } else {
                this.formShow = false;
            }
        },

        dateFormat(val) {
            if (val != null && val != "") {
                moment.locale("en-US");
                return moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
            } else {
                return "N/A";
            }
        },

        fileEdit(data) {
            this.modalId = data.id;
            this.modalFileName = data.fileName;
            this.$bvModal.show("modal-file-update");
        },

        linkEdit(data) {
            this.modalId = data.id;
            this.modalFileName = data.fileName;
            this.$bvModal.show("modal-file-update");
        },

        deleteFile(data) {
            this.$swal({
                title: "Are you sure?",
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, remove it!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.formShow = true;

                    axiosIns
                        .delete(`deleteVehicleFile/${data.id}`)
                        .then((res) => {
                            var tempList = [];
                            this.files.forEach((element) => {
                                if (element.id != data.id) {
                                    tempList.push(element);
                                }
                            });

                            this.files = tempList;
                            this.formShow = false;
                            this.getVehicleById();
                        })
                        .catch((error) => {
                            console.log("error delete ", error);
                        });
                }
            });
        },

        addNewFile() {
            this.$bvModal.show("modal-file");
        },

        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault();

            if (this.selectFileType) {
                if (this.percentCompleted == 100) {
                    var data = {
                        vehicle_id: router.currentRoute.params.id,
                        fileName: this.modalFileName,
                        fileLink: this.modalFile,
                        status: "A",
                    };

                    // Trigger submit handler
                    this.modalOkFile(data);
                }
            } else {
                var data = {
                    vehicle_id: router.currentRoute.params.id,
                    fileName: this.modalFileName,
                    fileLink: this.fileLink,
                    status: "B",
                };
                this.modalOkFile(data);
            }
        },

        handleUpdate(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault();
            // Trigger submit handler
            this.modalUpdate();
        },

        resetModal() {
            this.modalFileName = null;
            this.modalFile = null;
        },

        modalOkFile(data) {
            if (!this.checkFormValidity()) {
                return;
            }

            this.$nextTick(() => {
                this.$bvModal.hide("modal-file");
            });

            this.formShow = true;
            axiosIns
                .post("saveVehicleFile", data)
                .then((response) => {
                    this.files.push({
                        id: response.data.id,
                        fileName: response.data.fileName,
                        fileLink: response.data.fileLink,
                        status: response.data.status,
                    });

                    this.selectFileType = true;
                    this.fileLink = null;
                    this.modalFileName = null;
                    this.modalFile = null;

                    this.formShow = false;
                    this.getVehicleById();
                })
                .catch((error) => {
                    this.formShow = false;
                    console.log(error);
                });
        },

        modalUpdate(val) {
            if (!this.checkFormValidity()) {
                return;
            }

            this.$nextTick(() => {
                this.$bvModal.hide("modal-file-update");
            });

            this.formShow = true;

            var data = {
                id: this.modalId,
                fileName: this.modalFileName,
                fileLink: this.modalFile,
            };

            axiosIns
                .put("updateVehicleFile", data)
                .then((response) => {
                    this.modalFileName = null;
                    this.modalFile = null;

                    this.files.forEach((file) => {
                        if (file.id == this.modalId) {
                            file.fileName = response.data.fileName;
                        }
                    });

                    this.formShow = false;
                    this.getVehicleById();
                })
                .catch((error) => {
                    this.formShow = false;
                    console.log(error);
                });
        },

        fileSelected(event) {
            //  this.formShow = true;
            let formData = new FormData();
            formData.append("file", event);

            const config = {
                onUploadProgress: function(progressEvent) {
                    this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                }.bind(this),
            };

            axiosIns
                .post("uploadVehicleFile", formData, config)
                .then((response) => {
                    this.modalFile = response.data;

                    this.formShow = false;
                    this.getVehicleById();
                })
                .catch((error) => {
                    this.formShow = false;
                    console.log(error);
                });
        },

        checkFormValidity() {
            const nameValid = this.$refs.fileRules.checkValidity();
            const fileValid = this.$refs.fileRules.checkValidity();

            return fileValid && nameValid;
        },
    },

    computed: {
        dataMeta() {
            return {
                from: this.vehicleData.event_list.length != 0 ? 15 * (this.currentPageEvent - 1) + 1 : 0,
                to: 15 * (this.currentPageEvent - 1) + Number(15) < this.vehicleData.event_list.length ? 15 * (this.currentPageEvent - 1) + Number(15) : this.vehicleData.event_list.length,
                of: this.vehicleData.event_list.length,
            };
        },
        nameState() {
            return this.modalFileName != null && this.modalFileName != "" ? true : false;
        },

        fileState() {
            return this.modalFile != null && this.modalFile != "" ? true : false;
        },
        linkState() {
            let expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
            let regex = new RegExp(expression);
            let link = this.fileLink;
            if (link != null) {
                if (link.match(regex)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
    },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
@import "@core/scss/vue/libs/swiper.scss";
@import "~swiper/css/swiper.css";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.icon {
    stroke: black;
    fill: none;
    width: 36px;
    height: 36px;
    stroke-width: 0.6666666666666666;
}

.user-title {
    width: 100%;
    height: 100%;

    font-weight: bold;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
    align-items: center;
    margin: auto;
}

.user-badge {
    text-align: center;
    vertical-align: middle;

    width: 50%;
    align-content: center;
}
</style>

<style scoped>
.tab-class >>> .nav-item {
    position: relative;
    display: flex;
    justify-content: start;
}

.tab-class >>> .nav-vertical {
    padding-left: 0 !important;
}

.tab-class >>> .nav-pills .nav-link.active {
    width: 100%;
}
</style>
